import { FC, useState } from "react";
import { Typography, Button, Box, makeStyles, Chip, withStyles, createStyles, Theme } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import { MyGainsProps } from "../../interfaces";
import WithDrawGainsModal from "../Modals/WithDrawGainsModal";
import RelockGainsModal from "../Modals/RelockGainsModal";
import { NetworkName } from "../../store/Wallet/WalletFunction";
import moment from "moment";
import { appConfig } from "../../config";
import { Colors } from "../../helpers/theme";

const useStyles = makeStyles(() => ({
  root: {
    overflow: "hidden",
    "& .MuiTableCell-root": {
      "&:first-child": {
        width: "15%"
      },
      "&:nth-child(2)": {
        width: "15%"
      },
      "&:nth-child(3)": {
        width: "15%"
      },
      "&:nth-child(4)": {
        width: "15%"
      },
      "&:nth-child(5)": {
        width: "10%"
      },
      "&:nth-child(6)": {
        width: "30%"
      },
    },
  },
}));

const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
        width: "100%",
        padding: 0,
        opacity: 0.8,
        borderRadius: "15px",
        boxShadow: "none",
        transition: "background-color 0.3s ease, transform 0.3s ease",
        willChange: "transform",
        '&:nth-of-type(odd)': {
            backgroundColor: Colors.darkWhite,
        },
        '&:nth-of-type(even)': {
          backgroundColor: Colors.white,
        },
        '&:hover': {
            backgroundColor: Colors.secondaryWhite,
            cursor: 'pointer',
            transform: "scale(1.02)",
        },
    },
  }),
)(TableRow);

const MyGainsDesktopList: FC<MyGainsProps> = (props) => {
  const classes = useStyles();
  const [openGainsWithdrawModal, setOpenGainsWithdrawModal] = useState(false);
  const [openGainsRelockModal, setOpenGainsRelockModal] = useState(false);

  const handleWithDraw = () => {
    setOpenGainsWithdrawModal(true);
  };

  const handleRelock = () => {
    setOpenGainsRelockModal(true);
  };

  const timeBetweenMonths = moment
    .duration(moment(props.expiresAt).diff(moment()))
    .asMonths()
    .toFixed();
  const timeBetweenDays = moment
    .duration(moment(props.expiresAt).diff(moment()))
    .asDays()
    .toFixed();
  const timeBetweenHours = moment
    .duration(moment(props.expiresAt).diff(moment()))
    .asHours()
    .toFixed();

  //  console.log(dayHourMinute(props.expiresAt));

  const isRelockDisabled = props.scVersion !== Number(appConfig.latestLockContractVersion)

  return (
    <>
      <StyledTableRow className={classes.root}>
        {" "}
        {/** Flex Box main */}
        <TableCell align="left">
          <Box>
            <Typography variant="subtitle1" color="secondary">
              { props.duration + " "}
              {Number(props.duration) === 1
                ? "Month"
                : "Months"}
            </Typography>
          </Box>
        </TableCell>
        <TableCell align="left">
          <Typography variant="subtitle1" color={props.status.toUpperCase() === 'AWAITING_LOCK' ? 'error' : props.status.toUpperCase() === 'AVAILABLE'? 'primary' : 'textPrimary'}>
            {props.status.toUpperCase() === 'AWAITING_LOCK' ? 'PENDING' : props.status.toUpperCase()}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography variant="subtitle1" className="fw-bold" color="primary">
            {props.amount}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography variant="subtitle1" className="fw-bold" color="secondary">
            {props.address?.length > 4
              ? props.address?.substr(0, 6) +
                "..." +
                props.address?.substr(
                  props.address?.length - 6,
                  props.address?.length
                )
              : props.address}
          </Typography>
          <Typography color="secondary" variant="caption">
            {NetworkName(props.networkId)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="subtitle1" className="fw-bold" color="primary">
            {props.Tickets}
          </Typography>
        </TableCell>
        <TableCell align="right">
          <>
            <Box display="flex" justifyContent="flex-end">
              <Box>
                {
                  props.status === "staked"
                  ?
                    <Chip
                      label={`Unstake in ${
                        (Number(timeBetweenMonths) > 1)
                          ? timeBetweenMonths + " Months"
                          : (Number(timeBetweenDays) > 1)
                            ? timeBetweenDays + " Days"
                            : timeBetweenHours + " Hours"
                        }`
                      }
                      color="default"
                      variant="outlined"
                      size="medium"
                    />
                  :
                  props.status === "unlocked"
                  ?
                    <Chip
                      label="GAINS Withdrawn"
                      color="default"
                      variant="outlined"
                      size="medium"
                    />
                  :
                  props.status === "awaiting_lock"
                  ?
                    <Chip
                      label="Awaiting Transaction Confirmation"
                      color="default"
                      variant="outlined"
                      size="medium"
                    />
                  :
                  <Box display="flex">
                    <Box>
                      <Button
                        variant="outlined"
                        color="secondary"
                        className="mr-16"
                        classes={{ label: "fs-12" }}
                        onClick={handleWithDraw}
                      >
                        Withdraw GAINS
                      </Button>
                    </Box>
                    <Box>
                      <Button
                        variant="contained"
                        color="secondary"
                        classes={{ label: "fs-12" }}
                        disabled={
                           isRelockDisabled
                        }
                        onClick={handleRelock}
                      >
                        Restake GAINS
                      </Button>
                    </Box>
                  </Box>
                }
              </Box>
            </Box>
            {/* <Typography
              variant="subtitle1"
              align="right"
            >
              {props.status === "staked"
                ? `GAINS unstake in ${
                    (Number(timeBetweenMonths) > 1)
                      ? timeBetweenMonths + " Months"
                      : (Number(timeBetweenDays) > 1)
                        ? timeBetweenDays + " Days"
                        : timeBetweenHours + " Hours"
                  }
                `
                : props.status === "available" &&
                  `Restake ${props.Tickets} ticket(s)`}
              {props.status === "unlocked"
                ? `GAINS withdrawn`
                : ''
              }
            </Typography> */}
          </>
        </TableCell>
      </StyledTableRow>
      {
        openGainsWithdrawModal && (
          <WithDrawGainsModal
            open={openGainsWithdrawModal}
            setOpen={setOpenGainsWithdrawModal}
            subscriptionId={props.id}
            address={props.address}
            amount={props.amount}
            network={props.networkId}
            scVersion={props.scVersion}
          />
      )}
      {
        openGainsRelockModal && (
          <RelockGainsModal
            open={openGainsRelockModal}
            setOpen={setOpenGainsRelockModal}
            subscriptionId={props.id}
            duration={props.duration}
            amount={props.amount}
            tickets={props.Tickets}
            address={props.address}
            network={props.networkId}
            scVersion={props.scVersion}
          />
      )}
    </>
  );
};

export default MyGainsDesktopList;
